<template>
  <div class="col-lg-6 col-md-12 col-xs-12 px-6 cat-school-rank">
    <CatProficiencyRank />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import CatProficiencyRank from './CatProficiencyRank';

  export default {
    name: 'cat-subject-rank',

    props: [
      'selectedSubjectId',
    ],

    components: {
      CatProficiencyRank,
    },

    methods: {
      ...mapActions([
        'fetchFilterProficiencyRank',
        'fetchChildProficiencyRank',
      ]),
    },

    computed: {
      ...mapGetters({
        isParentUser: 'isParentUser',
        selectedChildId: 'getSelectedChildId',
        childProficiencyRank: 'getChildProficiencyRank',
        filterProficiencyRank: 'getFilterProficiencyRank',
      }),
    },

    beforeMount() {
      const filters = {};
      if (this.selectedSubjectId !== 0) {
        filters.subject_id = this.selectedSubjectId;
      }

      if (this.isParentUser) {
        filters.child_id = this.selectedChildId;
        this.fetchChildProficiencyRank(filters);
      }

      if (!this.isParentUser) {
        this.fetchFilterProficiencyRank(filters);
      }
    },

    watch: {
      selectedSubjectId(selected) {
        const filters = {};
        if (selected !== 0) {
          filters.subject_id = selected;
        }

        // Support Student
        if (!this.isParentUser && !this.filterProficiencyRank[selected]) {
          this.busy = true;
          this.fetchFilterProficiencyRank(filters)
            .then(() => {
              this.busy = false;
            });
        }

        // Support Parent
        if (this.isParentUser && !this.childProficiencyRank[selected]) {
          this.busy = true;
          filters.child_id = this.selectedChildId;
          this.fetchChildProficiencyRank(filters)
            .then(() => {
              this.busy = false;
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// CatSubjectRank.vue?0d57b615